const blueColors = [
  '#b1d4e0', // Baby Blue
  '#2e8bc0', // Blue
  '#146FcF', // Blue algo
  '#145da0', // Midnight Blue
  '#0c2d48', // Dark Blue
];
    
  export default blueColors;